var map = {
	"./contingent-workforce-management.md": [
		931,
		931
	],
	"./data-analytics-solutions.md": [
		999,
		999
	],
	"./recruiting-solutions.md": [
		840,
		840
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 243;
module.exports = webpackAsyncContext;